module.exports = __webpack_public_path__ + "img/confetti_1a.94944b7f.svg";